<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Giảng dạy" :link="[{ text: 'Giảng dạy', href: '../teaching' }]" />
      </div>
      <div class="d-flex align-end" :class="{ 'flex-column align-center ': $vuetify.breakpoint.smAndDown }">
        <v-btn
          v-if="windowWidth > 1000 && role.type !== 'inspector'"
          class="mr-6"
          outlined
          color="success"
          @click="exportExcel"
          :block="$vuetify.breakpoint.smAndDown"
        >
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-teaching']"
          depressed
          class="mr-6"
          color="primary"
          @click="addCore = !addCore"
          :block="$vuetify.breakpoint.smAndDown"
          :class="{ 'my-2': $vuetify.breakpoint.smAndDown }"
        >
          Phân công chính khóa
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-teaching']"
          outlined
          color="primary"
          @click="addExtra = !addExtra"
          :block="$vuetify.breakpoint.smAndDown"
          :class="{ 'mr-6': $vuetify.breakpoint.smAndDown }"
        >
          Phân công bổ trợ
        </v-btn>
      </div>
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <TeachingFilter :windowWidth="windowWidth" @onFilterChanged="refresh" ref="teachingFilter" />
    </v-card>
    <v-card outlined class="mx-4 elevation-0"> <TeachingDataTable ref="teachingDataTable" @edit="onEdit"/></v-card>

    <TeachingNewDialog :state="addCore" @done="onFilter" />
    <ExtraTeachingNewDialog :state="addExtra" />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import TeachingFilter from '@/modules/teacher/TeachingFilter.vue'
import TeachingDataTable from '@/modules/teacher/TeachingDataTable.vue'
import TeachingNewDialog from '@/modules/teacher/TeachingNewDialog'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import Vuetify from 'vuetify'
import Vue from 'vue'
import utils from '@/plugins/utils'
import ExtraTeachingNewDialog from '@/modules/teacher/ExtraTeachingNewDialog.vue'

Vue.use(Vuetify)
export default {
  components: {
    Breadcrumbs,
    TeachingFilter,
    TeachingNewDialog,
    TeachingDataTable,
    ExtraTeachingNewDialog
  },
  data() {
    return {
      createState: false,
      filterState: false,
      editState: false,
      addCore: false,
      deleteState: false,
      selectedTeaching: null,
      addExtra: false,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    ...mapState('teaching', ['teachings', 'searchParams']),
    ...mapGetters('auth', ['profile', 'role'])
  },
  methods: {
    ...mapActions('teaching', ['removeTeaching', 'fetchTeachings']),
    refresh(query) {
      this.$refs.teachingDataTable.refresh(query)
    },
    onFilter() {
      this.$refs.teachingFilter.onFilterChanged()
    },
    onEdit(item) {
      this.selectedTeaching = item
      this.editState = !this.editState
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let excelHeader = this.$refs.teachingDataTable.headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const filters = this.$options.filters
        const teachings = await this.fetchTeachings({ ...this.searchParams, _limit: -1 })
        const data = teachings.map(item => {
          if (item.teacher) {
            if (item.teacher.gender) {
              item.teacher.gender = filters.gender(item.teacher.gender)
            }
            if (item.teacher.dob) {
              item.teacher.dob = filters.ddmmyyyy(item.teacher.dob)
            }
          } else {
            item.teacher = { name: 'Chưa có giáo viên' }
          }
          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachGiangDay')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>
